const EmailIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="52"
      height="40"
      viewBox="0 0 52 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.95 0.449799H3.05C1.64172 0.449799 0.5 1.59142 0.5 2.9998V36.9998C0.5 38.408 1.64162 39.5498 3.05 39.5498H48.95C50.3583 39.5498 51.5 38.4081 51.5 36.9998V2.9998C51.5 1.59152 50.3584 0.449799 48.95 0.449799ZM49.8 36.9999C49.8 37.4693 49.4195 37.8498 48.95 37.8498H3.05C2.58054 37.8498 2.20003 37.4693 2.20003 36.9999V2.9998C2.20003 2.53034 2.58054 2.14983 3.05 2.14983H48.95C49.4195 2.14983 49.8 2.53034 49.8 2.9998V36.9999Z"
        fill="#FB2576"
      />
      <path
        d="M47.324 3.85311C47.0994 3.83348 46.8762 3.90391 46.7036 4.04894L27.094 20.5218C26.4616 21.0535 25.5385 21.0535 24.9061 20.5218L5.29666 4.04884C5.06407 3.8536 4.74492 3.79722 4.45954 3.90102C4.17416 4.00481 3.96578 4.25304 3.91299 4.55216C3.86019 4.85129 3.97096 5.1558 4.20355 5.35103L23.813 21.8231C25.0769 22.8873 26.9233 22.8873 28.1872 21.8231L47.7966 5.35113C47.9693 5.2062 48.0773 4.99861 48.0969 4.77399C48.1165 4.54937 48.0461 4.32615 47.9011 4.15353C47.7563 3.9807 47.5487 3.87273 47.324 3.85311Z"
        fill="#FB2576"
      />
      <path
        d="M16.8483 21.7059C16.5474 21.6387 16.2338 21.7397 16.0286 21.9698L4.12856 34.7198C3.91321 34.9403 3.83412 35.2603 3.92197 35.5557C4.00983 35.8513 4.25079 36.076 4.55161 36.1431C4.85253 36.2103 5.1661 36.1093 5.37129 35.8792L17.2713 23.1292C17.4867 22.9086 17.5658 22.5887 17.4779 22.2932C17.3901 21.9978 17.1492 21.773 16.8483 21.7059Z"
        fill="#FB2576"
      />
      <path
        d="M35.9714 21.9698C35.7663 21.7397 35.4526 21.6387 35.1517 21.7059C34.8508 21.773 34.6099 21.9978 34.5221 22.2932C34.4342 22.5888 34.5133 22.9086 34.7287 23.1292L46.6287 35.8792C46.9514 36.2097 47.479 36.222 47.8167 35.9069C48.1545 35.5917 48.1788 35.0646 47.8714 34.7197L35.9714 21.9698Z"
        fill="#FB2576"
      />
    </svg>
  );
};

export default EmailIcon;
